import { render, staticRenderFns } from "./ShowBasicAskOpinion.vue?vue&type=template&id=d9855b5e&scoped=true&"
import script from "./ShowBasicAskOpinion.vue?vue&type=script&lang=ts&"
export * from "./ShowBasicAskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./ShowBasicAskOpinion.vue?vue&type=style&index=0&id=d9855b5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9855b5e",
  null
  
)

export default component.exports